// extracted by mini-css-extract-plugin
module.exports = {"link":"_2LApi","image":"_1TMi5","SloppyPhoto":"_28SKJ","sloppyPhoto":"_28SKJ","wrap":"_1aAxl"};